import { Component, Input } from '@angular/core';

@Component({
  selector: 'rm-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent {
  @Input() disabled: boolean;
  @Input() design: 'normal' | 'primary' | 'alert' | 'gray' = 'normal';
  @Input() outlined: boolean = false;
  @Input() rounded: boolean = false;
  @Input() size: 'sm' | 'md' | 'lg' | 'xl' = 'md';
  @Input() class?: string;
}
